import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Badge } from './ds/Badge';

interface InfoBoxProps {
  text: string;
  badge?: string;
  link?: string | null;
  variant?: 'info' | 'warning' | 'success' | 'danger';
}

export const InfoBox = ({ text, badge, link = null, variant = 'info' }: InfoBoxProps) => {
  const navigate = useNavigate();

  const containerColors: Record<string, string> = {
    info:    'bg-brand-blue/10 border-brand-blue/20',
    warning: 'bg-brand-orange/10 border-brand-orange/20',
    success: 'bg-semantic-success/10 border-semantic-success/20',
    danger:  'bg-semantic-danger/10 border-semantic-danger/20',
  };
  const badgeVariants: Record<string, 'info' | 'warning' | 'success' | 'danger'> = {
    info:    'info',
    warning: 'warning',
    success: 'success',
    danger:  'danger',
  };

  return (
    <div className={`border ${containerColors[variant]} px-4 py-3`}>
      <div className="max-w-6xl mx-auto flex items-center gap-3">
        {badge && (
          <Badge variant={badgeVariants[variant]}>{badge}</Badge>
        )}
        <p
          className={`tb-body text-text-primary flex-1 ${link ? 'cursor-pointer hover:underline' : ''}`}
          onClick={() => link && navigate(link)}
        >
          {text}
        </p>
        {link && (
          <svg className="w-4 h-4 text-text-muted flex-shrink-0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
            <path d="M12.95 10.707l.707-.707L8 4.343 6.586 5.757 10.828 10l-4.242 4.243L8 15.657l4.95-4.95z"/>
          </svg>
        )}
      </div>
    </div>
  );
};
